import { render, staticRenderFns } from "./RegBrand.vue?vue&type=template&id=798eaffa&scoped=true"
import script from "./RegBrand.vue?vue&type=script&lang=js"
export * from "./RegBrand.vue?vue&type=script&lang=js"
import style0 from "./RegBrand.vue?vue&type=style&index=0&id=798eaffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798eaffa",
  null
  
)

export default component.exports